
module Elma.Bindings {

    export interface IRenderInputForm {
        name: string,
        myArray: KnockoutObservableArray<any>
    }

    export class RenderInputForm {

        /**
        * @param element <HTMLElement> - the element to whoom the binding is bound.
        * @param valueAccessor <KnockoutObservable<boolean>> - the value of the observable, the type is defined by the interface. Used to get the value from the observable by wrapping the observable in the valueAccessor fn.
        * @param allBindingsAccessor <KnockoutAllBindingsAccessor> - Knockout object that helps get the observable value through any binding - i think
        * @param viewModel <any> - the viewmodel in which the element is placed
        * @param bindingContext <KnockoutBindingContext> - not really sure what this does
        */

        private checkFields(element: HTMLElement, valueAccessor: () => IRenderInputForm) {
            var value = ko.unwrap(valueAccessor());
            if (!value.name && !value.myArray()) {
                console.debug("Remember to set properties: name and myArray in your renderForm data binding. Like: renderInputForm: { 'myArray': arrayName, 'name': 'fieldName'} ");
                return;
            }
            var inputName = value.name;
            var isVisible = false;
            var isRequired = false;
            var formArray = value.myArray();
            var arrayLength = formArray.length;
            for (let i = 0; i < arrayLength; i++) {
                var currentElm = formArray[i];
                isVisible = currentElm.name == inputName;
                if (isVisible) {
                    isRequired = currentElm.required;
                    break; // stop loop when we found our result
                }
            }
            var $elm = $(element);
            var $formGroupParent = $elm.closest(".js-form-group");    
            if (isVisible === true) {
                if ($formGroupParent) {
                    $formGroupParent.removeClass("hide");
                }
                $elm.prop("required", isRequired);
                $elm.removeClass("hide");
            } else {
                if ($formGroupParent) {
                    $formGroupParent.addClass("hide");
                }
                $elm.prop("required", false);
                $elm.addClass("hide");
            }
        };

        public init = this.checkFields;
        public update = this.checkFields;

    }
    // ! first letter in the bindingHandlers must be lowercase string, but only the first, so not the class initialization
    ko.bindingHandlers['renderInputForm'] = new RenderInputForm();
}